<template>
<div>
    <div class="merchmain">
        <img src="../../assets/shirt.png" class="shirt">   
        <h1>Merch Dropping Soon..</h1> 
    </div>
    <Footer/>    
</div>
</template>
<script>
import Footer from '../general/Footer'
export default {
    name:'Merch',
    components:{
        Footer
    }
}
</script>

<style scoped>
    .merchmain{
        margin-top: 3rem;
        width: 100%;
        display: flex;
        flex-direction: column;
        font-family: 'Amatic SC','san-serif';
        font-weight: 600;
        text-shadow: 0.1rem 0.1rem #7e70d4;
        font-size: 2em;
        justify-content: center;
        align-items: center;
        -webkit-user-select: none; /* Safari */
        -ms-user-select: none; /* IE 10+ and Edge */
        user-select: none; /* Standard syntax */
        -webkit-user-drag: none;
        margin-bottom: 15rem;
    }
    .shirt{
        width: 30rem;
        -webkit-user-select: none; /* Safari */
        -ms-user-select: none; /* IE 10+ and Edge */
        user-select: none; /* Standard syntax */
        -webkit-user-drag: none;
        pointer-events: none;
    }

 @media screen and (max-width:1024px){
     .shirt{
        width: 30rem;
    }
 }


 @media screen and (max-width:768px){
        .merchmain{
            margin-top: 8rem;
            font-size: 1.5em;
        }
        .shirt{
            width: 60%;
        }

 }

</style>